<template>
  <div id="Reason">
    <el-dialog
      title="红冲原因"
      width="400px"
      append-to-body
      @close="closeDialog"
      :visible.sync="visible"
      :show="show"
      :close-on-click-modal="false"
    >
      <div style="height: 196px;">
        <el-input
          type="textarea"
          maxlength="500"
          show-word-limit
          :rows="2"
          placeholder="请输入红冲原因"
          v-model="textarea"
        ></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="dataname(textarea)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: this.show,
      textarea: "",
      typeCode: 1
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    dataname(textarea) {
      if (textarea == "") {
        this.$message({
          showClose: true,
          message: "红冲原因不能为空",
          type: "warning"
        });
      } else {
        this.visible = false;
        this.$emit("textarea", textarea);
      }
    },
    // 关闭弹出框前回调
    closeDialog() {
      this.textarea = "";
      this.$emit("update:show", false);
    }
  },
  watch: {
    show() {
      this.visible = this.show;
    }
  }
};
</script>

<style lang="less">
.el-dialog__footer {
  padding: 0px 20px 10px;
  .dialog-footer {
    .el-button {
      padding: 8px 12px;
    }
  }
}
.el-textarea__inner {
  min-height: 200px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Common/Reason/Reason.vue